import { WebsiteSettingsModel } from "@insite/client-framework/Types/ApiModels";

// Copied from "@insite/client-framework/Common/Utilities/setPageMetadata"
export const generatePageTitle = (title: string, websiteName: string, websiteSettings?: WebsiteSettingsModel) => {
    if (!websiteSettings) {
        return websiteName + (title ? ` | ${title}` : "");
    }

    if (!websiteSettings.includeSiteNameInPageTitle) {
        return title;
    }

    return websiteSettings.siteNameAfterTitle
        ? `${title}${websiteSettings.pageTitleDelimiter}${websiteName}`
        : `${websiteName}${websiteSettings.pageTitleDelimiter}${title}`;
};
